// App.js or MainLayout.jsx
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { createTheme } from "@mui/material/styles";

import AppRoutes from "./components/AppRouters";
import axiosInstance from "./api/axiosInstance";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#007BFF", // ISA Blue
    },
    secondary: {
      main: "#FE2E79", // Accent light blue
    },
    background: {
      default: "#f2f2f2",
    },
  },
  typography: {
    fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
    h6: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 700,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          color: "fff",
          "&.Mui-disabled": {
            color: "#ffffffaa", // semi-transparent white
          },
        },

        contained: {
          background:
            "linear-gradient(260.52deg, #1c99fe -4.98%, #7644ff 48.42%, #fd4766)",
          color: "#fff",
          transition:
            "transform 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease",
          "&:hover": {
            opacity: 0.9,
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        },
      },
    },
  },
});

axiosInstance.interceptors.request.use((config) => {
  console.log("interceptor", config);
  const token =
    localStorage.getItem("crm_jwt_token") ||
    sessionStorage.getItem("crm_jwt_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppRoutes />
      </ThemeProvider>
    </Router>
  );
}
